module.exports = __webpack_public_path__ + "static/media/access_icon.a5f41648.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/access_icon.png
// module id = 1804
// module chunks = 0